import type { InteractionType } from '~/model/InteractionType';
import type { UserContribStatusCountType } from '~/model/UserContribStatusCountType';
import { statusContribution } from '~/const/api';
import appConst from '~/const/appConst';
import { checkContributionCount } from './count';

export function canInitialize({
  interaction,
  statusCount,
}: {
  interaction: InteractionType;
  statusCount?: UserContribStatusCountType;
}) {
  if (interaction?.['@type'] === appConst.entityTypes.thread) {
    return false;
  }

  const count = statusCount || interaction?.current_user_contribution?.count_per_status;

  const hasOther = count && Object.keys(count).some(
    key => count[key] > 0 && key !== statusContribution.initialized,
  );

  const hasInitalized = count && checkContributionCount({ count, value: 1 });

  return interaction?.can_have_multiple_contributions
    ? !hasInitalized
    : !hasInitalized && !hasOther;
}

export function cannotInitializeAgain(interaction: InteractionType, statusCount: UserContribStatusCountType) {
  return !canInitialize({ interaction, statusCount }) && !checkContributionCount({
    count: statusCount,
    value: 1,
  });
}
